import type { OrderbookSnapshot } from "../api/markets";

export function OrderbookPanel({ ob }: { ob: OrderbookSnapshot | null }) {
  if (!ob) return <div className="panel">Loading orderbook…</div>;
  const maxQty = Math.max(
    ...ob.bids.map((b) => b[1]),
    ...ob.asks.map((a) => a[1]),
    0.0001,
  );
  return (
    <div className="orderbook">
      <h4>Order book</h4>
      <div className="orderbook-side asks">
        {[...ob.asks].reverse().slice(0, 12).map(([p, q], i) => (
          <div key={`a${i}`} className="orderbook-row ask">
            <div className="orderbook-bg" style={{ width: `${(q / maxQty) * 100}%` }} />
            <span className="orderbook-price">{p.toFixed(2)}</span>
            <span className="orderbook-qty">{q.toFixed(3)}</span>
          </div>
        ))}
      </div>
      <div className="orderbook-spread">
        spread {(ob.asks[0]?.[0] - ob.bids[0]?.[0]).toFixed(2)}
      </div>
      <div className="orderbook-side bids">
        {ob.bids.slice(0, 12).map(([p, q], i) => (
          <div key={`b${i}`} className="orderbook-row bid">
            <div className="orderbook-bg" style={{ width: `${(q / maxQty) * 100}%` }} />
            <span className="orderbook-price">{p.toFixed(2)}</span>
            <span className="orderbook-qty">{q.toFixed(3)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
